export const incomingRequests = {

  "title": "Smart Matching",
  "subtitle": "Discover members who want to visit your region",
  "requests": {
    "title": "Requests",
    "count": "{{count}} request(s)",
    "empty": {
      "noListingDescription": "You don't have a listing yet. Publish one to receive requests."
    },
    "loading": "Loading requests...",
    "errors": {
      "notAuthenticated": "You must be logged in to view this page.",
      "loadFailed": "An error occurred while loading requests."
    },
    "defaultPropertyType": "Home",
    "sortOptions": {
      "recent": "Most recent",
      "rating": "Best rated",
      "distance": "Closer"
    }
  },
  "aiSection": {
    "title": "Smart suggestions",
    "subtitle": "Discover members that match your criteria",
    "distance": "Distance",
    "dates": "Dates",
    "guests": "Guests",
    "matchScore": "Match score",
    "search": "Search",
    "startDiscussion": "Start discussion",
    "viewProfile": "View profile",
    "away": "away"
  }
};
